import { setExaminerProfile, setExaminerProfileModal } from '../../../../../store/workspace/slice';
import { ApplicantProfileTab } from '../../../../../store/workspace/types';
import { useDispatch, useSelector } from '../../../../../store/store';
import { ProfileSquareIcon } from '../../../../../assets/icons';
import { applicantProfileTabs } from '../../../../../configs';
import Spinner from '../../../../../components/Spinner';
import Modal from '../../../../../components/Modal';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import PersonalInformation from './tabs/PersonalInformation';
import WorkExperience from './tabs/WorkExperience';
import UploadedFiles from './tabs/UploadedFiles';
import Identifying from './tabs/Identifying';
import Expertise from './tabs/Expertise';
import Education from './tabs/Education';
import ResumePDF from './ResumePDF';
import styles from './style.module.scss';
import {
    selectExaminerProfile,
    selecFetchingExaminerProfile,
} from '../../../../../store/workspace/selectors';

export default function ApplicantProfile() {
    const dispatch = useDispatch();
    const profile = useSelector(selectExaminerProfile);
    const fetching = useSelector(selecFetchingExaminerProfile);
    const [tab, setTab] = useState<ApplicantProfileTab>('Personal');

    const closeModal = () => dispatch(setExaminerProfileModal(false));

    useEffect(() => {
        return () => {
            dispatch(setExaminerProfile(null));
        };
    }, [dispatch]);

    const renderTab = () => {
        switch (tab) {
            case 'Expertise':
                return <Expertise data={profile?.experties} />;
            case 'Education':
                return <Education data={profile?.educationInfo} />;
            case 'WorkExperience':
                return <WorkExperience data={profile?.workExperience} />;
            case 'Identify':
                return <Identifying avatar={profile?.profilePhoto} kycStatus={profile?.kyc || ''} />;
            case 'Personal':
                return <PersonalInformation
                    data={profile}
                    salary={profile?.desiredAnnualSalaryRange}
                    visaStatus={profile?.requireSponsorshipVisa}
                />;
            case 'Files':
                return <UploadedFiles
                    resumeFileKey={profile?.resumeFileKey}
                    portfolioFileKey={profile?.portfolioFileKey}
                    resumeFileKeyLink={profile?.resumeFileKeyLink}
                    certificateFileKey={profile?.certificateFileKey}
                    coverLetterFileKey={profile?.coverLetterFileKey}
                    portfolioFileKeyLink={profile?.portfolioFileKeyLink}
                    certificateFileKeyLink={profile?.certificateFileKeyLink}
                    coverLetterFileKeyLink={profile?.coverLetterFileKeyLink}
                />;
            default:
                return null;
        }
    };

    return (
        <Modal
            size='xxl'
            icon={<ProfileSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={closeModal}
            title={`${profile ? `${profile.firstName} ${profile.lastName}` : 'Applicant'} - Information`}
            actions={fetching ? 'none' : 'dismiss'}
            dismissButton={{
                text: 'Close',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            actionsExtra={profile && <PDFDownloadLink
                className={styles.actions_link}
                document={<ResumePDF data={profile} />}
                fileName={`${profile.firstName}-${profile.lastName}.pdf`}
            >
                {({ loading }) => (loading ? 'Generating PDF...' : 'Download Applicant Profile')}
            </PDFDownloadLink>}
        >
            {fetching ? <div className={styles.loading}>
                <Spinner />
            </div> : <>
                <div className={styles.tabs}>
                    {applicantProfileTabs.map(item => <span
                        key={item.id}
                        className={styles.tab}
                        onClick={() => setTab(item.id)}
                        data-tab-active={tab === item.id}
                    >
                        {item.title}
                    </span>)}
                </div>
                <div className={styles.content}>
                    {renderTab()}
                </div>
            </>}
        </Modal>
    );
};
